import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class ManageSchema {
  async getWorkspaceSchemasWithPermissions(Workspace_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/manageSchemas/schemas`)).data;
  }

  async addOrUpdateSchemaDetail(Workspace_id, postData) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/manageSchemas/`, postData)).data;
  }

  async deleteSchemas(Workspace_id, schemas) {
    return (await fetchApi.delete(`/workspace/${Workspace_id}/manageSchemas/?schemas=${encodeURIComponent(schemas)}`))
      .data;
  }

  async getImportableSchemasFromSF(Workspace_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/manageSchemas/importSchemas`)).data;
  }
}
